import { logout } from "api/authenticate";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import * as auth from "../_redux/authRedux";

class Logout extends Component {
  componentDidMount() {
    this.props.logout();

    logout()
  }

  render() {
    const { hasAuthToken } = this.props;

    // Get referrer from query params
    let referrer = "";
    if (window.location && window.location.search) {
      const params = new URLSearchParams(window.location.search);
      referrer = params.get("referrer") || "";
    }

    const redirectTo = referrer
      ? `/auth/login?referrer=${encodeURIComponent(referrer)}`
      : "/auth/login";

    return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to={redirectTo} />;
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
  auth.actions
)(Logout);
